<template>
  <div class="dashboard-container">
    <!--<div class="dashboard-text">{{searchForm.datePicker}}</div>-->
    <!--<div class="dashboard-text">username:{{username}}</div>-->
    <el-form :inline="true" :model="searchForm">
      <el-form-item>
        <el-date-picker
          v-model="searchForm.datePicker"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :default-time="defaultTime"
          value-format="yyyy-MM-dd HH:mm:ss">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="loadData">查询</el-button>
      </el-form-item>
    </el-form>
    <el-row :gutter="10">
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
        <div>
          <el-button @click="changeType" style="margin-left: 90%" size="mini">图表切换</el-button>
          <ve-chart :data="lineData" :settings="lineData.chartSettings"></ve-chart>
        </div>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
        <div>
          <ve-pie :data="app_orders" :events="chartEvents" :settings="app_orders.chartSettings"></ve-pie>
        </div>
      </el-col>
    </el-row>
    <el-dialog el-dialog :visible.sync="dialogForm">
      <ve-chart :data="app_orders_line.rows" :setting="app_orders_line.chartSettings"></ve-chart>
    </el-dialog>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import moment from 'moment';
  import { getOrdersByTime } from '@/api/orders';
  import _groupBy_ from 'lodash/groupBy';
  import _find_ from 'lodash/find';
  import {getProductsAll} from '../../api/products';
  import {getApps} from '../../api/apps';
  import constant from '../../utils/constant';

  import _sortedUniq_ from 'lodash/sortedUniq';
  import promise from 'bluebird'

  function defaultDate () {
    return [
      moment().hours(0).minutes(0).seconds(0).subtract('6', 'days').format('YYYY-MM-DD HH:mm:ss'),
      moment().hours(23).minutes(59).seconds(59).format('YYYY-MM-DD HH:mm:ss')
    ];
  }

  export default {
    name: 'dashboard',
    computed: {
      ...mapGetters([
        'username',
        'roles'
      ])
    },
    data () {
      this.chartEvents = {
        click: this.appOrderPieClick
      }
      return {
        searchForm: {
          datePicker: defaultDate()
        },
        defaultTime: ['00:00:00', '23:59:59'],
        datePicker: defaultDate(),

        types: ['line','histogram'],
        index: 0,
        lineData: {
          chartSettings: {
            type: ''
          },
          columns: [],
          rows:[]
        },
        app_orders: {
          chartSettings: {},
          columns: [],
          rows:[]
        },
        app_orders_line: {
          chartSettings: {},
          columns: [],
          rows:[]
        },
        progress: constant.PROGRESS,
        orders: [],
        products: null,
        apps: null,
        name: '',
        dialogForm: false
      };
    },
    created () {
      this.loadData();
    },
    methods: {
      loadData () {
        if (!this.searchForm.datePicker) {
          this.searchForm.datePicker = defaultDate();
        } else {
          let startTime = moment(this.searchForm.datePicker[0]).date();
          let endTime = moment(this.searchForm.datePicker[1]).date();
          if (endTime - startTime > 6) {
            this.$message.error('时间间隔不能超过一周');
            return;
          }
        }

        promise.props({
          products: getProductsAll(),
          apps: getApps(),
          orders: getOrdersByTime({
            startTime: this.searchForm.datePicker[0],
            endTime: this.searchForm.datePicker[1]
          })
        }).then(result => {
          this.products = result.products;
          this.apps = result.apps;
          this.orders = result.orders;
          this.ordersChart();
          this.loadAppOrdersCountChart();
        });
      },
      changeType () {
        this.index = this.index ? 0 : 1;
        this.ordersChart();
      },
      /**
       * 订单量柱状图和折线图
       */
      ordersChart () {
        let groupByTime_arr = _groupBy_(this.orders, function (item) {
          return moment(item.createdAt).format('YYYY-MM-DD');
        });
        this.lineData.columns = ['date', 'notPaid', 'orderPaid', 'transitionSuccess', 'transitionFailure'];
        this.lineData.chartSettings.labelMap = {
          date: '日期',
          notPaid: '未支付',
          orderPaid: '已支付',
          transitionSuccess: '交易完成',
          transitionFailure: '交易失败'
        }
        this.lineData.chartSettings.yAxisName = ['订单量/笔'];
        this.lineData.chartSettings.type = this.types[this.index];
        let chartData = [];
        for (let date in groupByTime_arr) {
          let data = {};
          let progress = _groupBy_(groupByTime_arr[date], 'progress');
          data.date = date;
          data.notPaid = progress[this.progress.NOT_PAID] ? progress[this.progress.NOT_PAID].length : 0;
          data.orderPaid = progress[this.progress.ORDERPAID] ? progress[this.progress.ORDERPAID].length : 0;
          data.transitionSuccess = progress[this.progress.TRANSITION_SUCCESS] ? progress[this.progress.TRANSITION_SUCCESS].length : 0;
          data.transitionFailure = progress[this.progress.TRANSITION_FAILURE] ? progress[this.progress.TRANSITION_FAILURE].length : 0;
          chartData.push(data);
        }
        this.lineData.rows = chartData;
      },
      /**
       * 应用订单量--饼状图
       */
      loadAppOrdersCountChart () {
        // 交易成功订单
        let groupByProgress = _groupBy_(this.orders, 'progress')[this.progress.TRANSITION_SUCCESS];
        // 按商品ID给订单分组
        let groupByProduct = _groupBy_(groupByProgress, 'productId');
        // 商品ID
        // let productIds = Object.keys(groupByProduct);
        // 根据ID得到商品信息
        let productList = Object.keys(groupByProduct).map(proId => {
          return _find_(this.products, {id: parseInt(proId)})
        });
        // 根据商品信息得到app
        let appList = _sortedUniq_(productList.map(product => {
          return _find_(this.apps, {appIndex: parseInt(product.appIndex)})
        }));
        let chartData = appList.map(app => {
          // 某个APP所有商品的订单总数
          let productOrdersCount = 0;
          let thisAppProducts = [];
          productList.forEach(product => {
            if (app.appIndex === product.appIndex) {
              thisAppProducts.push(product);
              productOrdersCount += groupByProduct[product.id].length
            }
          });
          return {'app': app.name, 'orderCount': productOrdersCount, 'products': thisAppProducts}
        });
        this.app_orders = {
          rows: chartData,
          columns: ['app', 'orderCount'],
          chartSettings: {
            labelMap: {
              app: '应用',
              ordersCount: '订单量'
            },
            dimension: 'app',
            metrics: 'orderCount',
            selectedMode: 'single',
            hoverAnimation: false
          }
        }
      },
      appOrderPieClick (e) {
        this.name = e.name;
        console.log(e);
        console.log(this.app_orders.rows[e.dataIndex]);
      }
    }
  };
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .dashboard {
    &-container {
      margin: 30px;
    }
    &-text {
      font-size: 30px;
      line-height: 46px;
    }
  }
</style>



// WEBPACK FOOTER //
// home.vue?17c06fe8